<svg-icon [name]="icon" *ngIf="icon"></svg-icon>

<span class="body-1-medium">
  <ng-content></ng-content>
</span>
